<div class="filter">
    <form class="filter-search" 
        [class.active]="isActive" 
        [formGroup]="formGroup" 
        (ngSubmit)="submit()"
        (click)="onClicked($event)">
        <input class="search-field" #searchInput 
            placeholder="{{placeholderText}}"
            [attr.data-is-active]="isActive ? 'Y' : ''" 
            formControlName="search" required>        
        <i *ngIf="isSearching" class="fa fa-hourglass search-icon"></i>
        <i *ngIf="!isSearching" class="fas fa-search search-icon"></i>
    </form>
</div>